import { Component, Input } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import moment from 'moment-timezone';
import { VizFormModule } from '../../common/components/form/form.module';
import { SessionService } from '../../session.service';
import { BookHour } from '../booking.session.service';
import { formatDisplayTime } from '../site.format.mixin';
import { SpaceBookContainer } from '../space.book.container';
import { Thinkdesks } from '../thinkdesks';
@Component({
  selector: 'app-book-date-select-combined',
  standalone: true,
  styles: [
    `
      .hourChip {
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 5px 10px;
        width: fit-content;
        margin: 5px;
        text-align: center;
        cursor: pointer;
        &.selected {
          background-color: blue;
        }
        &.disabled {
          background-color: #ccc;
          color: white;
          cursor: no-drop;
        }
      }
    `,
  ],
  imports: [VizFormModule, MatDatepickerModule],
  templateUrl: './book.date.select.combined.html',
})
export class BookDateSelectCombined {
  _common = _common;
  @Input()
  container: SpaceBookContainer;
  constructor(private session: SessionService) {}
  ngOnInit() {}
  now = moment();

  slotText(c: BookHour) {
    let q = this.container.object.bookSlotIncrement;
    let t = c.time;
    let end = t.clone().add(Thinkdesks.BOOK_MINS * q);

    let time = t.moment(this.now);
    let endTime = end.moment(this.now);
    return `${formatDisplayTime(this.session, time)} - ${formatDisplayTime(
      this.session,
      endTime
    )}`;
  }
}
